<template>
    <!-- background: url(../assets/images/bg.png); -->
    <div id="app" :class="{ mobilev: isMobileLayout, deskv: !isMobileLayout }"
        :style="$theme.darkTheme ? '' : 'background: #f2f3f7'">
        <UiToastList />
        <!-- Instância única das sheets do fluxo de download (qualidade,
             confirmar remoção/cancelamento, rede móvel). Qualquer componente
             pergunta via services/download/downloadSheets e dá await. -->
        <DownloadSheets />
        <!-- Pedido de permissão contextual e aviso "silenciar curso" do push
             (STORY-1642). Só existe no app. -->
        <PushSheets v-if="$isApp" />
        <OfflineSyncDebug v-if="showOfflineSyncPanel" />
        <transition name="relogin-fade">
            <div v-if="reloginPending" class="relogin-overlay">
                <img :src="splashLogo" class="relogin-overlay__logo"
                    :style="{ '--pulse-color': $theme.primaryColor }" alt="PagTrust" />
            </div>
        </transition>
        <ComposedHeader ref="header" v-if="hasHeader" :layout-theme="currentLayoutTheme"></ComposedHeader>
        <router-view @openLeftMenu="headerOpenMenu($event)"></router-view>
        <ModalMyGroup :layout-theme="currentLayoutTheme"></ModalMyGroup>
        <ModalMyCertificate :layout-theme="currentLayoutTheme"></ModalMyCertificate>
        <ModalProfile :layout-theme="currentLayoutTheme"></ModalProfile>
        <ModalConfiguration :layout-theme="currentLayoutTheme"></ModalConfiguration>
        <ModalNotes :layout-theme="currentLayoutTheme"></ModalNotes>
        <ModalSubscriptions :layout-theme="currentLayoutTheme"></ModalSubscriptions>
        <ModalSupport :layout-theme="currentLayoutTheme"></ModalSupport>
        <ModalCourseFiles :layout-theme="currentLayoutTheme"></ModalCourseFiles>
        <Footer v-if="hasFooter" :layout-theme="currentLayoutTheme"></Footer>
        <script type="module">
      import Chatbox from "https://cdn.pagtrust.ai/dist/chatbox/index.js";

      window.enableChatBot = async function (
        agentId,
        agentImage,
        enableHumanSupport,
        humanSupportOptions,
        humanSupportMessage,
        enrollId,
        currentUser,
        shopWindowId,
        userImageUrl
      ) {
        if (window.widget) return;

        const [firstName, lastName] = currentUser.name ? currentUser.name.split(' ') : ['', ''];
        const phoneNumber = currentUser.phones[0]?.area && currentUser.phones[0]?.number
    ? (currentUser.phones[0]?.ddi ?? '55') + (currentUser.phones[0]?.area ?? '') + (currentUser.phones[0]?.number ?? '')
    : '';
       var humanSupportConfig=enableHumanSupport? humanSupportOptions+1:0;
        window.widget = await Chatbox.initBubble({
          agentId: agentId,
          enrollId: enrollId,
          userMktId: currentUser.studentId,
          shopWindowId: shopWindowId,
          humanSupportConfig: humanSupportConfig,
          humanSupportMessage: humanSupportMessage,
          userIconUrl: userImageUrl || '',
          contact: {
            email: currentUser.email ||'',
            firstName: firstName ?? '',
            lastName: lastName ?? '',
            phoneNumber: phoneNumber ?? '',
          },
          containerClassName: "coremedia-ignore",
          interface: {
            iconUrl: agentImage || "https://cdn.pagtrust.ai/icon.png",
            initialMessages: ["Olá, como posso lhe ajudar?"],
            position: "right",
          },
        });
      };

      window.minimizeChatBot = async function () {
        window.widget.open();
        setTimeout(() => {
          window.widget.close();
        });
      };
    </script>
    </div>
</template>

<script>
import ComposedHeader from "./ComposedHeader.vue";
import Footer from "./Footer.vue";
import UiToastList from "@/components/UI/UiToastList";
import DownloadSheets from '@/components/DownloadSheets';
import PushSheets from '@/components/push/PushSheets';
import ModalProfile from "@/pages/modals/Profile";
import ModalConfiguration from "@/pages/modals/Configuration";
import ModalNotes from "@/pages/modals/Notes";
import ModalSubscriptions from "@/pages/modals/Subscriptions";
import ModalSupport from "@/pages/modals/Support";
import ModalMyGroup from "@/pages/modals/MyGroup";
import ModalMyCertificate from "@/pages/modals/MyCertificate";
import ModalCourseFiles from "@/pages/modals/CourseFiles";
import DrmPurgeNotice from "@/components/DrmPurgeNotice";
import OutdatedLessonsNotice from "@/components/OutdatedLessonsNotice";
import OfflineSyncDebug from "@/components/dev/OfflineSyncDebug";

import { mapState } from "vuex";

export default {
    name: "AppLayout",
    components: {
        DownloadSheets,
        PushSheets,
        ComposedHeader,
        Footer,
        ModalProfile,
        ModalConfiguration,
        ModalNotes,
        ModalSubscriptions,
        ModalMyGroup,
        ModalMyCertificate,
        ModalSupport,
        ModalCourseFiles,
        UiToastList,
        OfflineSyncDebug,
    },
    data() {
        return {
            isMobileLayout: this.detectMobile(),
            touchstartY: 0,
            touchmoveY: 0,
            isRefreshing: false,
            isTouchingChatbot: false,
            isChatBubbleOpen: false
        };
    },
    computed: {
        ...mapState({
            currentLayoutTheme: (state) => state.user.currentUser.layoutTheme,
            selectedEnroll: (state) => state.enroll.current,
            pendingDrmPurge: (state) => state.download.pendingDrmPurge,
            pendingOutdatedNotice: (state) => state.download.pendingOutdatedNotice,
            reloginPending: (state) => state.dom.reloginPending,
        }),
        hasHeader() {
            const routeMetaHeader = this.$route.meta.header;

            switch (routeMetaHeader) {
                case "no-header":
                    return false;
                case "dark":
                    this.$store.dispatch("user/setCurrentTheme", "dark");
                    return true;
                case "light":
                    this.$store.dispatch("user/setCurrentTheme", "light");
                    return true;
            }
        },
        hasFooter() {
            const routeMetaFooter = this.$route.meta.footer;

            switch (routeMetaFooter) {
                case "no-footer":
                    return false;
                case "dark":
                    this.$store.dispatch("user/setCurrentTheme", "dark");
                    return true;
                case "light":
                    this.$store.dispatch("user/setCurrentTheme", "light");
                    return true;
            }
        },
        headerMeta() {
            const headerMetaParams = this.$route.meta.headerMeta;
            if (headerMetaParams) return headerMetaParams;
            else return {};
        },
        // Mesmo logo do splash de boot (public/logo.png via BASE_URL) — o overlay
        // de relogin espelha aquele splash. Não usa $appLogoSrc (logo configurável
        // do produtor) de propósito: aqui é a marca PagTrust, como no index.html.
        splashLogo() {
            return (process.env.BASE_URL || '/') + 'logo.png';
        },
        showOfflineSyncPanel() {
            // Diagnóstico é só pra equipe interna ($isInternalUser): mesmo que o
            // toggle tenha ficado ligado (ex.: troca de conta no mesmo device),
            // aluno comum não vê o painel.
            return this.$isInternalUser && this.$store.getters['download/getShowOfflineSyncPanel'];
        },
    },
    watch: {
        // immediate cobre boot com pendência remanescente (purga cortada por kill).
        pendingDrmPurge: {
            immediate: true,
            handler (value, prev) {
                if (value && !prev) {
                    this.$modal.show(DrmPurgeNotice, {
                        courseName: value.courseName,
                        loCount: value.loCount,
                    }, {
                        name: 'drm-purge-notice',
                        classes: 'drm-purge-notice-wrapper',
                        clickToClose: false,
                        escToClose: false,
                        height: 'auto',
                        adaptive: true,
                        width: '86%',
                        maxWidth: 420,
                    });
                }
            }
        },
        pendingOutdatedNotice: {
            immediate: true,
            handler (value, prev) {
                const changed = value && (!prev || String(prev.enrollId) !== String(value.enrollId));
                if (!changed) return;
                if (prev) this.$modal.hide('outdated-lessons-notice');
                this.$modal.show(OutdatedLessonsNotice, {
                    courseName: value.courseName,
                    names: value.names || [],
                    count: value.count || 0,
                    kind: value.kind || 'updated',
                    updatedCount: value.updatedCount || 0,
                    removedCount: value.removedCount || 0,
                    canDownload: Boolean(value.redownloadLoIds && value.redownloadLoIds.length),
                    enrollId: value.enrollId,
                    orphanLoIds: value.orphanLoIds || [],
                    redownloadLoIds: value.redownloadLoIds || [],
                }, {
                    name: 'outdated-lessons-notice',
                    classes: 'outdated-lessons-notice-wrapper',
                    clickToClose: false,
                    escToClose: false,
                    height: 'auto',
                    adaptive: true,
                    width: '86%',
                    maxWidth: 420,
                });
            }
        }
    },
    mounted() {
        window.addEventListener("toggle-opened-chatbubble", this.handleChatBubbleToggle);
        document.addEventListener('touchstart', this.onTouchStart, { passive: false });
        document.addEventListener('touchmove', this.onTouchMove, { passive: false });
    },
    beforeDestroy() {
        window.removeEventListener("toggle-opened-chatbubble", this.handleChatBubbleToggle);
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        this.removeChatOpenStyles();
    },

    methods: {
        detectMobile() {
            const isSmallScreen = window.innerWidth <= 768;
            const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

            return isSmallScreen || hasTouchScreen || isMobileUserAgent;
        },
        applyChatOpenStyles() {
           if (!this.isMobileLayout) return;

            const html = document.documentElement;
            const body = document.body;

            html.classList.add('disable-refresh-body-html', 'disable-refresh-html');
            body.classList.add('disable-refresh-body', 'disable-refresh-body-html');

            window.addEventListener('scroll', this.handleScrollWhenBubbleOpen, { passive: true });

            this.$nextTick(() => {
              const chatEl = document.querySelector(".coremedia-ignore");
              if (chatEl) {
                chatEl.shadowRoot.querySelector(".chaindesk-chatbox-bubble-jkocdx").style.padding = "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)";
              }
            });
        },
        removeChatOpenStyles() {
            if (!this.isMobileLayout) return;

            const html = document.documentElement;
            const body = document.body;

            html.classList.remove('disable-refresh-body-html', 'disable-refresh-html');
            body.classList.remove('disable-refresh-body', 'disable-refresh-body-html');

            window.removeEventListener('scroll', this.handleScrollWhenBubbleOpen);
        },
        headerOpenMenu(classId) {
            this.$refs.header.openLeftMenu(classId);
        },
        // O card do chatbox escolhe layout por LARGURA (breakpoint sm do MUI):
        // >=600px ganha altura fixa de 680px ancorada acima do FAB. Celular em
        // paisagem tem ~900px de largura e ~380px de altura — o card estourava o
        // topo da tela e cobria a página. Em viewport baixo, esta folha (injetada
        // no shadowRoot, que CSS de fora não alcança) replica o layout fullscreen
        // do breakpoint xs, o mesmo que o retrato já usa. Tablets em paisagem
        // (altura maior) não entram na media query.
        //
        // Vive AQUI, não no <script> inline do template: o compilador de template
        // do Vue condensa os newlines do texto do script, e qualquer comentário
        // `//` engoliria o resto do código numa linha só (SyntaxError).
        injectChatLandscapeFix() {
            const host = document.querySelector("chaindesk-chatbox-bubble");
            if (!host || !host.shadowRoot || host.shadowRoot.getElementById("vxl-chat-landscape-fix")) return;
            const style = document.createElement("style");
            style.id = "vxl-chat-landscape-fix";
            style.textContent = `
              @media (min-width: 600px) and (max-height: 540px) {
                .chaindesk-widget > div:not(.chaindesk-launcher) {
                  position: fixed !important;
                  top: 0 !important;
                  right: 0 !important;
                  bottom: 0 !important;
                  left: 0 !important;
                  width: 100vw !important;
                  max-width: 100vw !important;
                  height: auto !important;
                  transform: none !important;
                }
                .chaindesk-widget > div:not(.chaindesk-launcher) > div {
                  min-height: 0 !important;
                  max-height: 100% !important;
                }
              }
            `;
            host.shadowRoot.appendChild(style);
        },
        handleChatBubbleToggle(eventData) {
            const isOpen = eventData.detail?.isOpen;
            this.isChatBubbleOpen = isOpen;

            if (isOpen) {
                this.injectChatLandscapeFix();
                this.applyChatOpenStyles();
                if(window.scrollY === 0) {
                  setTimeout(() => {
                      window.scrollTo({
                          top: 2,
                          behavior: 'smooth'
                      });

                      setTimeout(() => {
                          window.scrollTo(0, 2);
                          document.documentElement.scrollTop = 2;
                          document.body.scrollTop = 2;
                      }, 100);
                  }, 100);
                }
            } else {
                this.removeChatOpenStyles();
            }
        },
        onTouchStart(e) {
          this.touchstartY = e.touches[0].clientY;

          const chatbotElement = document.querySelector('chaindesk-chatbox-bubble');
          this.isTouchingChatbot = chatbotElement && chatbotElement.contains(e.target);
        },
        onTouchMove(e) {
          this.touchmoveY = e.touches[0].clientY;
          const isScrollingUp = this.touchmoveY > this.touchstartY;

          if (this.isTouchingChatbot && window.scrollY === 0 && isScrollingUp) {
              e.preventDefault();
          }
        },
        handleScrollWhenBubbleOpen() {
            if (!this.isChatBubbleOpen) return;

            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollY <= 1) {

                setTimeout(() => {
                    window.scrollTo({
                        top: 2,
                        behavior: 'smooth'
                    });

                    setTimeout(() => {
                        if (window.pageYOffset <= 1) {
                            window.scrollTo(0, 2);
                            document.documentElement.scrollTop = 2;
                            document.body.scrollTop = 2;
                        }
                    }, 50);
                }, 10);
            }
        }
    },
};
</script>

<style>
.disable-refresh-html {
    height: 100%;
    overflow-x: hidden;
}
.disable-refresh-body {
    touch-action: manipulation;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.disable-refresh-body-html {
    overscroll-behavior: none;
    overscroll-behavior-y: none;
    -webkit-overscroll-behavior: none;
    -webkit-overscroll-behavior-y: none;
}

.relogin-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: env(safe-area-inset-top) 24px env(safe-area-inset-bottom);
    /* Fundo segue o esquema do SO (igual ao splash de boot do index.html),
       não o tema do produtor. */
    background: #ffffff;
}
@media (prefers-color-scheme: dark) {
    .relogin-overlay {
        background: #000000;
    }
}
.relogin-overlay__logo {
    height: 8rem;
    width: 8rem;
    object-fit: contain;
    animation: relogin-logo-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
/* Logo pulsando com um halo na cor de preferência do user (--pulse-color),
   espelhando o splash de boot do public/index.html. */
@keyframes relogin-logo-pulse {
    0%, 100% { opacity: 1; filter: drop-shadow(0 0 0 var(--pulse-color, transparent)); }
    50% { opacity: 0.5; filter: drop-shadow(0 0 16px var(--pulse-color, transparent)); }
}
.relogin-fade-enter-active,
.relogin-fade-leave-active {
    transition: opacity 0.25s ease;
}
.relogin-fade-leave-active {
    pointer-events: none;
}
.relogin-fade-enter,
.relogin-fade-leave-to {
    opacity: 0;
}
</style>
